export default "__VITE_ASSET__77616a82__"